export default __webpack_public_path__ + "static/media/circuit-composer.86761df6.png";